import { Modal, Table, } from "react-bootstrap";
import { useEffect, useState } from "react";

import { calcularMontoArray } from "../../utils/utils";
import LoadingModal from "../LoadingModal/LoadingModal";
import axios from "axios";
import Convenio from "../../pages/Secciones/GestionLegal/Actuaciones/Convenio";
import "./PlanDePago.css";

const PlanDePagoModal = ({ data, show, handleClose, filters, getPlanes, convenio }) => {
  const [loading, setLoading] = useState(false);
  const [planPago, setPlanPago] = useState(false);


  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        if (data.NRO_PLAN) {
          let config = {
            tipo: 1,
            plan: data.NRO_PLAN,
            imponible: "",
            recurso: "",
            cuota: "",
            anio: "",
          };

          let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/consultas/estadoPlnPago.php", { data: config });

          if (response?.data) {
            setLoading(false);
            setPlanPago(response.data);
            await getPlanes(filters);
          }
          else {
            setLoading(false);
          }
        }
        else {
          setLoading(false);
        }
      }
      catch (err) {
        console.log(err);
        setLoading(false);
      }
    };

    if(!convenio){
      getData();
    }

  }, [data]);


  return (
    <Modal
      show={show}
      size="xl"
      onHide={handleClose}
      className="plandepago-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {convenio ? `Convenio- NRO ${convenio}` : `Plan de Pago - NRO ${data.NRO_PLAN} (${planPago.estado})`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="table-planpago" style={{ overflow: "auto" }}>
        {convenio ? (
          <Convenio convenioId={convenio} />
        ) :
          (
            <Table className="subtable" striped bordered hover>
              <tbody>
                <tr >
                  <td colSpan={1} className="subtable-subtitulo">
                  CUOTA
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  CAPITAL
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  INT. ORIGINAL
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  TOTAL
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  FECHA DE VENCIMIENTO
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  INT. FINANCIERO
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  FECHA DE COBRANZA
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  TIPO COMPROBANTE
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  NÚMERO COMPROBANTE
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  ESTADO DEL LA CUOTA
                  </td>
                  <td colSpan={1} className="subtable-subtitulo">
                  ESTADO DE PLAN
                  </td>
                </tr>
                {planPago?.cuotas?.length ? planPago?.cuotas.map((e, i) => {
                  return (
                    <tr key={"tr" + i}>
                      <td>
                        {e?.CUOTA}
                      </td>
                      <td>
                        {e?.MONTO_CAPITAL ? "$" + e?.MONTO_CAPITAL : null}
                      </td>
                      <td>
                        {e?.MONTO_INTERES ? "$" + e?.MONTO_INTERES : null}
                      </td>
                      <td>
                        {e?.MONTO ? "$" + e?.MONTO : null}
                      </td>
                      <td>
                        {e?.FECHA_VTO}
                      </td>
                      <td>
                        {e?.INT_COBRANZA ? "$" + e?.INT_COBRANZA : null}
                      </td>
                      <td>
                        {e?.FECHA_COBRANZA ? e?.FECHA_COBRANZA : null}
                      </td>
                      <td>
                        {e?.TIPO_COMPROB}
                      </td>
                      <td>
                        {e?.NRO_COMPROB}
                      </td>
                      <td>
                        {
                          new Date(new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()) > new Date(e.FRM_FECHA) ?
                            <p>{e?.FECHA_COBRANZA ? <span style={{ fontWeight: 600, color: "green" }} >COBRADA</span> : <span style={{ fontWeight: 600, color: "red" }} >VENCIDA</span>}</p> :
                            <span style={{ fontWeight: 600, color: "green" }} >VIGENTE</span>
                        }
                      </td>
                      <td></td>
                    </tr>
                  );
                }) : null}
                <tr>
                  <td className="p-3"><b>TOTAL:</b></td>
                  <td className="p-3">{planPago?.cuotas?.length ? "$" + calcularMontoArray(planPago?.cuotas, "MONTO_CAPITAL") : ""}</td>
                  <td className="p-3">{planPago?.cuotas?.length ? "$" + calcularMontoArray(planPago?.cuotas, "MONTO_INTERES") : ""}</td>
                  <td className="p-3">{planPago?.cuotas?.length ? "$" + calcularMontoArray(planPago?.cuotas, "MONTO") : ""}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="p-3">
                    <b>{planPago.estado}</b>
                  </td>
                </tr>
              </tbody>
            </Table>
          )}
      </Modal.Body>
      {loading ? <LoadingModal show={loading} loading={true} /> : null}
    </Modal>
  );
};



export default PlanDePagoModal;